﻿import { api } from "./api.js";

const enc = encodeURIComponent;
export const getValuationData = (t) => api(`/stocks/${enc(t)}/valuation`);
export const getInsiders = (t) => api(`/stocks/${enc(t)}/insiders`);
export const getModelInputs = (t) => api(`/stocks/${enc(t)}/model-inputs`);
export const getReleases = (t) => api(`/stocks/${enc(t)}/releases`);

export const getQuarterly = (t, count = 13) => api(`/stocks/${enc(t)}/quarterly?count=${count}`);
